/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import React, { Component } from "react";
import { Provider } from "react-redux";

import configureStore from "./store";
import MetricPaletteViewer from "./MetricPaletteViewer";
import { isEqual } from "../../utils/lodash-utils";

class MetricPalette extends Component {
  constructor(props) {
    super(props);
    this.store = configureStore();
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.fromGroup || nextProps.fromCsView || nextProps.fromUrl) {
      if (
        !isEqual(nextProps.devices, this.props.devices) ||
        !isEqual(nextProps.singleDevice, this.props.singleDevice) ||
        !isEqual(nextProps.isTreeOpen, this.props.isTreeOpen) ||
        !isEqual(nextProps.isInterface, this.props.isInterface) ||
        !isEqual(nextProps.masterId, this.props.masterId) ||
        !isEqual(nextProps.name, this.props.name)
      ) {
        return true;
      } else return false;
    } else return true;
  }

  render() {
    return (
      <div style={{height:'100%'}}>
        <Provider store={this.store}>
          <MetricPaletteViewer {...this.props} />
        </Provider>
      </div>
    );
  }
}

export default MetricPalette;

export { MetricPalette };
